import { API_ENDPOINTS } from '../config/api';
import { authenticatedFetch } from '../utils/authenticatedFetch';
import type { MondayBriefApiResponse } from '../types/profitabilityBrief';

export async function fetchMondayBrief(params: {
  date_from: string;
  date_to: string;
  margin_threshold_pct?: number;
  organisation_name?: string;
}): Promise<MondayBriefApiResponse> {
  const qs = new URLSearchParams({
    date_from: params.date_from,
    date_to: params.date_to,
  });
  if (params.margin_threshold_pct != null) {
    qs.set('margin_threshold_pct', String(params.margin_threshold_pct));
  }
  if (params.organisation_name) {
    qs.set('organisation_name', params.organisation_name);
  }

  const res = await authenticatedFetch(`${API_ENDPOINTS.profitabilityMondayBrief()}?${qs.toString()}`);
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(body || `Monday brief failed (${res.status})`);
  }
  return (await res.json()) as MondayBriefApiResponse;
}
